export const allowedWords = ["tight", "leade", "ashed"];
